<h3 *ngIf="agentForm.controls.id.value">Edit Agent</h3>
<h3 *ngIf="!agentForm.controls.id.value">Add Agent</h3>

<div class="agent-edit-container">
    <form [formGroup]="agentForm" (ngSubmit)="onSubmit()"  >

        <input formControlName="id" type="hidden">

        <mat-form-field class="agent-form-field">
            <mat-label>Machine</mat-label>
            <mat-select formControlName="machineId" required>
                <mat-option *ngFor="let machine of machines" [value]="machine.id">
                    {{machine.serialNumber}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="agent-form-field">
            <mat-label>Enabled</mat-label>
            <mat-select formControlName="enabled" required>
                <mat-option [value]="true" >Enabled</mat-option>
                <mat-option [value]="false" >Disabled</mat-option>
            </mat-select>
        </mat-form-field>

        <button mat-raised-button color="primary" type="reset" (click)="clear()" class="editActionButton">Clear</button>
        <button mat-raised-button color="primary" type="submit" class="editActionButton" [disabled]="!agentForm.valid">Save</button>

    </form>

    <!-- Useful during the dev  

    <p>
        Form Status: {{ agentForm.status }}
        Form Value: {{ agentForm.value | json}}
    </p>
  -->
</div>

